export default "<div #mainElement class=\"bg\">\n  <div class=\"text\">\n    {{text}}\n  </div>\n</div>\n";